import styled from "styled-components";
import theme from "../common/theme";

const ProgressBar = styled.div`
    width: 100%;
    height: ${props => props.height || '0.5rem'};
    background: ${theme.palette.light};
    border: 1px solid ${theme.palette.border};
    border-radius: 5px;
    padding: 1px;
    overflow: hidden;
    margin: 0.3rem 0;
`

const Progress = styled.div`
    position: relative;
    height: 100%;
    width: ${props => props.progress}%;
    background: ${theme.palette.dark};
`

export default ({ progress, height, ...rest }) => {
    return (<ProgressBar height={height} {...rest} >
        <Progress progress={progress} {...rest} />
    </ProgressBar>)
};